module.exports = {
        srcSet: __webpack_public_path__ + "static/media/paper-and-pen-500.246224c0.webp"+" 500w",
        images: [{path: __webpack_public_path__ + "static/media/paper-and-pen-500.246224c0.webp",width: 500,height: 500}],
        src: __webpack_public_path__ + "static/media/paper-and-pen-500.246224c0.webp",
        toString: function(){return __webpack_public_path__ + "static/media/paper-and-pen-500.246224c0.webp"},
        
        width: 500,
        height: 500
      }